// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"5270dec8","462":"fc5c447a","653":"5270dec8","933":"5270dec8"}[chunkId] + ".chunk.css";
};